<template>
  <footer class="footer-bg border-t border-gray/20">
    <div class="!py-10 container grid grid-cols-12 gap-6 justify-between">
      <div class="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-5">
        <RouterLink to="/home">
          <img
            class="w-[170px]"
            src="/landing/logo/saraf-logo-white.svg"
            alt="Saraf Logo"
          />
        </RouterLink>
        <p class="mt-7 mb-11 text-white text-sm leading-140">
          {{ $t("landing.contacts.support_service_description") }}
        </p>
        <div class="flex md:items-center gap-4">
          <RouterLink
            class="text-sm text-white font-medium hover:text-green transition-300"
            v-for="(item, index) in links"
            :key="index"
            :to="item?.url"
          >
            {{ $t(item?.title) }}
          </RouterLink>
        </div>
      </div>
      <span class="max-md:hidden md:col-span-2 lg:col-span-3" />
      <div
        class="col-span-12 sm:col-span-6 md:col-span-5 lg:col-span-4 flex-between flex-col gap-y-8"
      >
        <div class="flex-y-center flex-col gap-3">
          <div
            class="gap-3 mt-3 flex items-start mr-auto flex-row rtl:ml-auto rtl:mr-0"
            v-for="(item, index) in contactLinks"
            :key="index"
          >
            <i :class="`${item?.icon} text-2xl leading-8 text-white`" />
            <div>
              <p class="text-white text-xs font-normal">
                {{ $t(item?.title) }}
              </p>
              <a
                v-if="item?.title !== 'Location'"
                :href="item?.link"
                target="_blank"
                class="text-base font-bold text-white hover:text-green transition-300 max-sm:max-w-[166px] max-sm:w-full"
                >{{ $t(item?.subtitle) }}</a
              >

              <a
                v-else
                href="https://www.google.com/maps?q=25.18822,55.25836"
                target="_blank"
                class="text-base font-bold text-white hover:text-green transition-300 max-sm:max-w-[166px] max-sm:w-full !direction-ltr"
                >{{ $t(item?.subtitle) }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py-3 md:py-5 border-t border-gray/20">
      <div
        class="container flex-center-between items-center relative text-xs leading-normal text-white max-md:flex-col gap-3"
      >
        <p class="">
          © Saraf {{ new Date().getFullYear() }},
          {{ $t("landing.footer.all_rights_reserved") }}
        </p>
        <div
          class="flex items-center justify-between gap-6 md:absolute top-1/2 left-1/2 md:-translate-y-1/2 md:-translate-x-1/2"
        >
          <template v-for="(item, index) in socials" :key="index">
            <a
              :href="item?.link"
              target="_blank"
              :class="`flex-y-center justify-center w-8 h-8 text-xl leading-8 rounded-full text-text-white hover:text-green transition-300`"
            >
              <span :class="item?.icon" />
            </a>
          </template>
        </div>
        <div class="flex md:items-center gap-4">
          <RouterLink
            class="text-xs text-white font-medium hover:text-green transition-300"
            v-for="(item, index) in termsLinks"
            :key="index"
            :to="item?.url"
          >
            {{ $t(item?.title) }}
          </RouterLink>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { links } from "@/data";

const contactLinks = computed(() => [
  {
    title: "landing.contacts.phone_number",
    subtitle: "971-54-357-1111",
    link: `tel:+971543571111`,
    icon: "icon-phone",
  },
  {
    title: "landing.contacts.dubai_office",
    subtitle: "Single business tower “3905, 3906” Dubai, UAE",
    link: "https://www.google.com/maps?q=25.18822,55.25836",
    icon: "icon-map-pin",
  },
  {
    title: "landing.contacts.contact_us_at",
    subtitle: "support@sarafrobot.com",
    link: ``,
    icon: "icon-mail",
  },
]);

const socials = computed(() => [
  // {
  //   name: 'Facebook',
  //   link: '',
  //   icon: 'icon-facebook',
  // },
  // {
  //   name: 'X (Twitter)',
  //   link: '',
  //   icon: 'icon-twitter text-lg',
  // },
  // {
  //   name: 'YouTube',
  //   link: '',
  //   icon: 'icon-youtube',
  // },
  {
    name: "Instagram",
    link: "https://www.instagram.com/sarafrobot",
    icon: "icon-instagram text-lg",
  },
  {
    name: "Telegram",
    link: "https://t.me/sarafrobot_support",
    icon: "icon-telegram",
  },
]);

const termsLinks = [
  {
    title: "landing.footer.term_of_service",
    url: "/home",
  },
  {
    title: "landing.footer.privacy_policy",
    url: "/home",
  },
];
</script>
<style scoped>
.footer-bg {
  background: linear-gradient(
    134.77deg,
    #0a241a -13.51%,
    #131c18 50.28%,
    #181a18 125.16%
  );
}
</style>
